<template>
  <section class="target">
    <div class="container">
      <a-typography>
        <a-typography-title :level="1">
          体验CostPilot，轻松达成云成本优化目标！
        </a-typography-title>
        <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$RQ.GoGSS()">
          免费体验
        </a-button>
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalFormCollection','demo')">
          预约咨询
        </a-button>
      </a-space>
      </a-typography>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_target',
  methods: {
    /**
     * 点击按钮
     */
    async clickButton(): Promise<any> {
      window._hmt && window._hmt.push([ '_trackEvent', 'CostPilot_3', 'click' ]);
      await $FN.WaitTime(100);
      $Store.Page().openModal('modalFormCollection', 'freeUse');
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productCostPilot/';

.target {
  overflow: hidden;
  position: relative;
  background-color: @color_6;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    text-align: center;
    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: 0;
    }
    
    &::before {
      top: 10px;
      left: 0;
      .bg('@{image}icon_4_1.png', 91px, 62px, true);
    }
    
    //&::after {
    //    right: 0;
    //    bottom: 10px;
    //    .bg('@{image}icon_4_2.png', 118px, 44px, true);
    //}
  }
}

article.ant-typography {
  position: relative;
  
  h1.ant-typography {
    position: relative;
    margin: 0;
    .font(center, 40px, @color_white, 30px, true);
  }
}

.button_1 {
  margin: 20px 0 0;
  background-color: @color_white !important;
  color: @color_6 !important;
}

@media screen and (max-width: -1px+@grid_md) {
  .target {
    .container {
      padding: @space_mo 0;
      text-align: center;
      &::before {
        .transform(translate(-10px, -10px) scale(0.6));
      }
    }
  }
  
  article.ant-typography {
    h1.ant-typography {
      .font(center, 30px, @color_white, 18px, true);
    }
  }
  
  .button_1 {
    margin: @margin_mo 0 0;
  }
}
</style>